<template>
  <span />
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';

const emit = defineEmits<{
  mounted: [];
  unmounted: [];
}>();

onMounted(() => {
  emit('mounted');
});

onBeforeUnmount(() => {
  emit('unmounted');
});
</script>

<i18n lang="json">{}</i18n>
